import { Empty } from 'antd'
import React from 'react'
import styled from 'styled-components'

export const StyledEmpty = styled(Empty)`
  margin: 64px auto;
  .ant-empty-description {
    font-size: 12px;
    color: ${props => props.theme['neutral-400']};
  }
  .ant-empty-image {
    width: auto;
    margin-bottom: 24px;
    img {
      height: 100px;
      width: auto;
    }
  }
`

export const MyEmpty: React.FC<{
  showImage?: boolean
  image?: string
  description?: React.ReactNode
  style?: React.CSSProperties
  className?: string
}> = ({ showImage = true, image, description, style, className }) => {
  return (
    <StyledEmpty
      style={style}
      className={className}
      description={description || '暂无数据'}
      imageStyle={{
        display: showImage ? 'block' : 'none',
      }}
      image={image || '/images/empty@2x.png'}
    />
  )
}
